<div class="ride-request-container">
  <p-toast />
  <p-confirmDialog />



  <p-tabView styleClass="custom-tabview">
    <p-tabPanel header="Solicitar Carrera" leftIcon="pi pi-send">
      <!-- Paso 1: Buscar Cliente -->
      @if (step === 'search') {
        <div class="search-step">
          <div class="search-card">
            <h2>✨ Solicitar Carrera</h2>
            <p class="subtitle">Ingresa el número de teléfono del cliente para comenzar</p>

            <div class="search-form">
              <div class="form-group">
                <label for="phone-input">📱 Teléfono del Cliente</label>
                <div class="input-wrapper">
                  <input
                    #phoneInput
                    id="phone-input"
                    type="text"
                    [(ngModel)]="phoneSearch"
                    placeholder="0987654321"
                    (keyup.enter)="searchUser()"
                    pInputText
                  />
                </div>
              </div>

              <button
                pButton
                type="button"
                label="Buscar"
                icon="pi pi-search"
                (click)="searchUser()"
                class="search-btn"
              ></button>
            </div>
          </div>
        </div>
      }

      <!-- Paso 2: Crear Cliente -->
      @if (step === 'create-user') {
        <div class="create-user-step">
          <div class="create-user-card">
            <h2>➕ Crear Nuevo Cliente</h2>
            <p class="subtitle">Este cliente no existe en el sistema. Completa los datos para registrarlo:</p>

            <form [formGroup]="userForm" class="user-form">
              <div class="form-row">
                <div class="form-group col">
                  <label for="usr-name">👤 Nombre Completo *</label>
                  <input
                    id="usr-name"
                    type="text"
                    formControlName="usr_name"
                    pInputText
                    placeholder="Juan Carlos"
                  />
                </div>
                <div class="form-group col">
                  <label for="usr-last-name">👤 Apellido *</label>
                  <input
                    id="usr-last-name"
                    type="text"
                    formControlName="usr_last_name"
                    pInputText
                    placeholder="García López"
                  />
                </div>
              </div>

              <div class="form-actions">
                <button
                  pButton
                  type="button"
                  label="Volver"
                  icon="pi pi-arrow-left"
                  severity="secondary"
                  (click)="step = 'search'; phoneSearch = ''; userForm.reset()"
                ></button>
                <button
                  pButton
                  type="button"
                  label="Crear y Continuar"
                  icon="pi pi-check"
                  (click)="createUser()"
                ></button>
              </div>
            </form>
          </div>
        </div>
      }

      <!-- Paso 3: Crear Carrera -->
      @if (step === 'create-trip') {
        <div class="create-trip-step">
          <!-- Cliente + Mapa juntos -->
          <div class="trip-top">
            <!-- Información del Cliente -->
            @if (foundUser) {
              <div class="client-info-card">
                <h3>Información del Cliente</h3>
                <div class="client-info">
                  <p>
                    <strong>Nombre</strong>
                    <span>{{ foundUser.usr_name }} {{ foundUser.usr_last_name }}</span>
                  </p>
                  <p>
                    <strong>Teléfono</strong>
                    <span>{{ foundUser.usr_phone }}</span>
                  </p>
                </div>

                @if (foundUser.list && foundUser.list.length > 0) {
                  <div class="saved-addresses">
                    <h4>📌 Direcciones guardadas</h4>
                    <ul class="saved-address-list">
                      @for (addr of foundUser.list; track addr.add_web_id) {
                        <li class="saved-address-item">
                          <div class="saved-address-info">
                            <span class="saved-address-street">{{ addr.add_web_street }}</span>
                            @if (addr.add_web_reference) {
                              <span class="saved-address-reference">{{ addr.add_web_reference }}</span>
                            }
                          </div>
                          <button
                            pButton
                            type="button"
                            label="Usar"
                            icon="pi pi-check"
                            size="small"
                            severity="secondary"
                            class="use-address-btn"
                            (click)="selectSavedAddress(addr)"
                          ></button>
                        </li>
                      }
                    </ul>
                  </div>
                }
              </div>
            }

            <!-- Mapa -->
            <div class="map-panel" #mapPanel>
              <div class="map-header">
                <h3>Mapa</h3>
                <div class="legend">
                  <div class="legend-item">
                    <span class="legend-color origin"></span>
                    <span>Origen</span>
                  </div>
                  <div class="legend-item">
                    <span class="legend-color destino"></span>
                    <span>Destino</span>
                  </div>
                </div>
              </div>

              <!-- Modo de edición visible: qué punto fija el próximo clic -->
              <div class="point-mode-toggle">
                <button
                  pButton
                  type="button"
                  label="Fijar origen"
                  icon="pi pi-map-marker"
                  class="mode-btn mode-origin"
                  [class.active]="editingPoint === 'origin'"
                  (click)="setEditingPoint('origin')"
                ></button>
                <button
                  pButton
                  type="button"
                  label="Fijar destino"
                  icon="pi pi-flag"
                  class="mode-btn mode-destino"
                  [class.active]="editingPoint === 'destino'"
                  (click)="setEditingPoint('destino')"
                ></button>
              </div>

              <google-map
                #map
                [center]="mapCenter"
                [zoom]="mapZoom"
                [options]="mapOptions"
                width="100%"
                height="100%"
                (mapClick)="onMapClick($event)"
                class="map"
              />

              <p
                class="map-hint"
                [class.editing-origin]="editingPoint === 'origin'"
                [class.editing-destino]="editingPoint === 'destino'"
              >
                @if (editingPoint === 'origin') {
                  🟠 Toca el mapa o arrastra el marcador para fijar el <strong>Origen</strong>
                } @else {
                  🟢 Toca el mapa o arrastra el marcador para fijar el <strong>Destino</strong>
                }
              </p>

              <button
                pButton
                type="button"
                label="Ver ruta"
                icon="pi pi-map"
                class="view-route-btn"
                [disabled]="!canShowRoute"
                (click)="showRoute()"
              ></button>
            </div>
          </div>

          <!-- Cálculo manual + aviso permanente de qué falta -->
          <div class="estimate-actions">
            <button
              pButton
              type="button"
              label="Presiona aquí para calcular el costo"
              icon="pi pi-calculator"
              class="calculate-btn"
              [disabled]="!canEstimate"
              (click)="estimate()"
            ></button>
            <p
              class="missing-hint"
              [class.warn]="!canEstimate"
              [class.info]="canEstimate && !estimationDone"
              [class.ok]="estimationDone"
            >
              @if (!canEstimate) {
                ⚠️
              } @else if (!estimationDone) {
                ℹ️
              } @else {
                ✅
              }
              {{ missingHint }}
            </p>
          </div>

          <!-- Resumen de estimación (atenuado hasta que se calcula) -->
          <div class="estimate-summary" [class.pending]="!estimationDone">
            <div class="estimate-tile time">
              <span class="estimate-icon">⏱️</span>
              <div class="estimate-data">
                <span class="estimate-label">Tiempo estimado</span>
                <span class="estimate-value">{{ estimatedTimeLabel }}</span>
              </div>
            </div>
            <div class="estimate-tile distance">
              <span class="estimate-icon">📏</span>
              <div class="estimate-data">
                <span class="estimate-label">Distancia</span>
                <span class="estimate-value">{{ estimatedDistanceMiles | number: '1.2-2' }} mi</span>
              </div>
            </div>
            <div class="estimate-tile price">
              <span class="estimate-icon">💵</span>
              <div class="estimate-data">
                <span class="estimate-label">Tarifa estimada</span>
                <div class="price-field">
                  <span class="price-currency">$</span>
                  <input
                    id="estimated-price"
                    type="text"
                    inputmode="numeric"
                    class="price-input-text"
                    [value]="priceDisplay"
                    (keydown)="onPriceKeydown($event)"
                    autocomplete="off"
                  />
                  <i class="pi pi-pencil price-edit-hint" title="Editable"></i>
                </div>
              </div>
            </div>
          </div>

          <!-- Controles de dirección (bajo el mapa) -->
          <form [formGroup]="tripForm" class="trip-form">
            <!-- Bloque Origen -->
            <div class="address-block origin-block">
              <div class="address-block-header">
                <h3>📍 Punto de Origen</h3>
                <button
                  pButton
                  type="button"
                  label="Ver en mapa"
                  icon="pi pi-map-marker"
                  severity="secondary"
                  size="small"
                  class="locate-btn"
                  (click)="goToOrigin()"
                ></button>
              </div>

              <div class="form-group">
                <label for="origin-search">🔎 Buscar dirección de origen</label>
                <input
                  #originSearchInput
                  id="origin-search"
                  type="text"
                  [(ngModel)]="originSearch"
                  [ngModelOptions]="{ standalone: true }"
                  pInputText
                  placeholder="Av. Amazonas 1200, Quito"
                  autocomplete="off"
                />
                <small class="hint">💡 Escribe y elige una sugerencia, o arrastra el marcador. Este campo no se guarda.</small>
              </div>

              <div class="form-group">
                <label for="origin-confirmed">✅ Dirección confirmada *</label>
                <div class="confirmed-field">
                  <i class="pi pi-lock confirmed-icon"></i>
                  <textarea
                    id="origin-confirmed"
                    formControlName="add_name"
                    pInputTextarea
                    [autoResize]="true"
                    rows="2"
                    readonly
                    placeholder="Selecciona una sugerencia o ubica el marcador en el mapa"
                  ></textarea>
                </div>
                <small class="hint">🔒 Generada automáticamente desde el mapa. No editable.</small>
              </div>

              <div class="form-group">
                <label for="origin-reference">Referencia o Punto de Referencia</label>
                <input
                  id="origin-reference"
                  type="text"
                  formControlName="add_reference"
                  pInputText
                  placeholder="Ej: Frente a la farmacia, cerca del árbol grande"
                />
              </div>
            </div>

            <!-- Bloque Destino -->
            <div class="address-block destino-block">
              <div class="address-block-header">
                <h3>🎯 Punto de Destino</h3>
                <button
                  pButton
                  type="button"
                  label="Ver en mapa"
                  icon="pi pi-map-marker"
                  severity="secondary"
                  size="small"
                  class="locate-btn"
                  (click)="goToDestino()"
                ></button>
              </div>

              <div class="form-group">
                <label for="destino-search">🔎 Buscar dirección de destino</label>
                <input
                  #destinoSearchInput
                  id="destino-search"
                  type="text"
                  [(ngModel)]="destinoSearch"
                  [ngModelOptions]="{ standalone: true }"
                  pInputText
                  placeholder="Calle Pichincha 456, Quito"
                  autocomplete="off"
                />
                <small class="hint">💡 Escribe y elige una sugerencia, o arrastra el marcador. Este campo no se guarda.</small>
              </div>

              <div class="form-group">
                <label for="destino-confirmed">✅ Dirección confirmada *</label>
                <div class="confirmed-field">
                  <i class="pi pi-lock confirmed-icon"></i>
                  <textarea
                    id="destino-confirmed"
                    formControlName="add_name_destino"
                    pInputTextarea
                    [autoResize]="true"
                    rows="2"
                    readonly
                    placeholder="Selecciona una sugerencia o ubica el marcador en el mapa"
                  ></textarea>
                </div>
                <small class="hint">🔒 Generada automáticamente desde el mapa. No editable.</small>
              </div>

              <div class="form-group">
                <label for="destino-reference">Referencia o Punto de Referencia</label>
                <input
                  id="destino-reference"
                  type="text"
                  formControlName="add_reference_destino"
                  pInputText
                  placeholder="Ej: Entrada por el parqueadero, oficina 3er piso"
                />
              </div>
            </div>

            <div class="form-actions">
              <button
                pButton
                type="button"
                label="Volver"
                icon="pi pi-arrow-left"
                severity="secondary"
                (click)="step = 'search'; phoneSearch = ''; foundUser = null; tripForm.reset()"
              ></button>
              <button
                pButton
                type="button"
                label="Solicitar Carrera"
                icon="pi pi-send"
                [disabled]="!canRequest"
                (click)="submitTrip()"
              ></button>
            </div>
          </form>
        </div>
      }

      <!-- Paso 4: Esperando Conductor -->
      @if (step === 'waiting-driver') {
        <div class="waiting-step">
          <div class="waiting-card">
            <h2>⏳ Esperando Conductor</h2>
            <p class="subtitle">Buscando un conductor disponible en tu zona...</p>

            <div class="countdown-container">
              <div class="countdown-timer">
                <span class="countdown-number">{{ countdown }}</span>
                <span class="countdown-text">segundos</span>
              </div>
              <p class="countdown-message">Si no hay respuesta, la solicitud será cancelada automáticamente</p>
            </div>

            <div class="loading-animation">
              <div class="spinner"></div>
            </div>

            <button
              pButton
              type="button"
              label="Cancelar Solicitud"
              icon="pi pi-times"
              severity="danger"
              (click)="cancelWaiting()"
              class="cancel-btn"
            ></button>
          </div>
        </div>
      }

      <!-- Paso 5: Resultado (Conductor Asignado) -->
      @if (step === 'trip-result' && tripResult === 'assigned' && assignedDriver) {
        <div class="trip-result-step">
          <div class="result-card success">
            <h2>✅ ¡Conductor Asignado!</h2>

            <div class="driver-info-card">
              <div class="driver-header">
                <h3>🚕 Información de la Carrera</h3>
              </div>

              <div class="driver-profile-container">
                <!-- Columna 1: Avatar del Conductor -->
                <div class="profile-avatar-column">
                  <div class="avatar-ring">
                    @if (assignedDriver.urlPhoto) {
                      <img [src]="assignedDriver.urlPhoto" alt="Conductor" class="profile-img" />
                    } @else {
                      <div class="placeholder-avatar">
                        <i class="pi pi-user"></i>
                      </div>
                    }
                  </div>
                  <div class="verified-tag">
                    <i class="pi pi-verified"></i> Verificado
                  </div>
                </div>

                <!-- Columna 2: Detalles del Conductor y Vehículo -->
                <div class="profile-details-column">
                  <h4 class="driver-full-name">{{ assignedDriver.driverName }} {{ assignedDriver.driverLastName }}</h4>
                  <div class="rating-stars">
                    <i class="pi pi-star-fill"></i>
                    <i class="pi pi-star-fill"></i>
                    <i class="pi pi-star-fill"></i>
                    <i class="pi pi-star-fill"></i>
                    <i class="pi pi-star-fill"></i>
                    <span>5.0</span>
                  </div>
                  
                  <div class="vehicle-mini-details">
                    <span class="vehicle-plate">{{ assignedDriver.plate }}</span>
                  </div>
                </div>
              </div>

              <!-- Foto del Vehículo (Ancho Completo abajo) -->
              @if (assignedDriver.urlPhotoVehicle) {
                <div class="vehicle-full-width-container">
                  <div class="vehicle-image-card">
                    <img [src]="assignedDriver.urlPhotoVehicle" alt="Vehículo" class="vehicle-img-full" />
                  </div>
                </div>
              }

              <!-- Resumen numérico en un grid destacado -->
              <div class="ride-summary-grid">
                <div class="summary-item">
                  <span class="label">Tiempo de Llegada</span>
                  <span class="value duration">⏱️ {{ assignedDriver.minArrival }} min</span>
                </div>
                <div class="summary-item">
                  <span class="label">Costo del Viaje</span>
                  <span class="value price">${{ assignedDriver.price | number: '1.2-2' }}</span>
                </div>
              </div>
            </div>

            <p class="success-message">El conductor está en camino a tu ubicación.</p>

            <div class="result-actions">
              <button
                pButton
                type="button"
                label="Ver detalle de carrera"
                icon="pi pi-eye"
                (click)="openTripDetail(currentTripId)"
                class="action-btn detail-btn"
              ></button>
              <button
                pButton
                type="button"
                label="Nueva Carrera"
                icon="pi pi-plus"
                (click)="newRideRequest()"
                class="action-btn"
              ></button>
            </div>
          </div>
        </div>
      }
    </p-tabPanel>

    <p-tabPanel header="Carreras" leftIcon="pi pi-history">
      <div class="history-panel">
        <div class="history-header">
          <div class="header-info">
            <h2>📋 Carreras</h2>
            <p class="subtitle">Registros de carreras realizadas en el rango de fechas seleccionado</p>
          </div>
          <div class="header-actions">
            <button
              pButton
              type="button"
              label="Exportar a Excel"
              icon="pi pi-file-excel"
              class="export-btn"
              (click)="exportToExcel()"
            ></button>
          </div>
        </div>

        <div class="filters-card">
          <div class="filters-grid">
            <div class="filter-group">
              <label for="date-start">📅 Fecha Inicio</label>
              <p-calendar
                [(ngModel)]="dateStart"
                [showIcon]="true"
                inputId="date-start"
                [showOnFocus]="false"
                dateFormat="dd-mm-yy"
                (onSelect)="onFilterChange()"
                class="custom-calendar"
              ></p-calendar>
            </div>

            <div class="filter-group">
              <label for="date-end">📅 Fecha Fin</label>
              <p-calendar
                [(ngModel)]="dateEnd"
                [showIcon]="true"
                inputId="date-end"
                [showOnFocus]="false"
                dateFormat="dd-mm-yy"
                (onSelect)="onFilterChange()"
                class="custom-calendar"
              ></p-calendar>
            </div>

            <div class="filter-group">
              <label for="status-select">🏷️ Estado</label>
              <p-dropdown
                id="status-select"
                [options]="ltsStatus"
                [(ngModel)]="selectedStatus"
                optionLabel="label"
                optionValue="value"
                placeholder="Selecciona un estado"
                (onChange)="onFilterChange()"
                class="custom-dropdown"
              ></p-dropdown>
            </div>
          </div>
        </div>

        <div class="table-card">
          <p-table
            #dtCarTrip
            [value]="ltsCarTrips"
            [lazy]="true"
            (onLazyLoad)="loadCarTrips($event)"
            [paginator]="true"
            [rows]="size"
            [first]="page * size"
            [totalRecords]="totalRecords"
            [rowsPerPageOptions]="[5, 10, 20, 50]"
            styleClass="p-datatable-striped p-datatable-gridlines custom-table"
            [responsiveLayout]="'scroll'"
          >
            <ng-template pTemplate="header">
              <tr>
                <th>Cliente</th>
                <th>Teléfono</th>
                <th>Fecha de solicitud</th>
                <th>Origen</th>
                <th>Conductor</th>
                <th>Estado</th>
                <th>Detalle</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-carTrip>
              <tr>
                <td class="font-semibold">{{ carTrip.usr_name }} {{ carTrip.usr_last_name }}</td>
                <td>{{ carTrip.usr_phone }}</td>
                <td>
                  <span class="no-break text-sm">{{ carTrip.car_tri_date | date : "dd-MM-yyyy HH:mm:ss" }}</span>
                </td>
                <td class="cell-address" [title]="carTrip.add_name_origin || 'Sin información'">
                  {{ carTrip.add_name_origin || 'Sin información' }}
                </td>
                <td>
                  <span class="font-medium" *ngIf="carTrip.dri_name">
                    {{ carTrip.dri_name }} {{ carTrip.dri_last_name }}
                  </span>
                  <span class="text-muted" *ngIf="!carTrip.dri_name">Sin información</span>
                </td>
                <td>
                  <span class="status-badge" [ngClass]="statusClass(carTrip.st_name)">
                    {{ carTrip.st_name || 'Sin información' }}
                  </span>
                </td>
                <td>
                  <button
                    pButton
                    type="button"
                    icon="pi pi-eye"
                    label="Ver"
                    size="small"
                    severity="secondary"
                    (click)="openTripDetail(carTrip.car_tri_id_trip)"
                  ></button>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="7" class="text-center no-records">
                  <div class="empty-state">
                    <span class="empty-icon">📭</span>
                    <p>No se encontraron carreras en el rango de fechas seleccionado.</p>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </p-tabPanel>
  </p-tabView>
</div>
